import styled, { css } from 'styled-components';

import { xdlColorBackground, xdlColorSelected } from '@xing-com/tokens';

export const Container = styled.div<{ $autoplayEnabled: boolean }>`
  :global(.vjs-has-started) .container {
    display: flex;
  }

  :global(.xing-vjs-menu-visible) .container {
    display: none;
  }

  :global(.video-js)
    .toggleContainer
    input:checked:focus:not(:global().focus-visible) {
    background-color: ${xdlColorSelected};
  }

  :global(.video-js) .toggleContainer input:focus:not(:global().focus-visible) {
    background-color: ${xdlColorBackground};
  }
  :hover:global(.vjs-has-started.vjs-user-inactive) .container,
  :global(.vjs-has-started) .container {
    opacity: 0;
    transition:
      visibility 1s,
      opacity 1s;
  }

  :hover:global(.vjs-has-started) .container {
    opacity: 1;
    transition:
      visibility 1s,
      opacity 1s;
  }

  align-items: center;
  background-color: rgba(44, 44, 44, 0.7);
  border-radius: 3.6em;
  display: none;
  justify-content: center;
  margin: 2.3em;
  padding: 0.8em;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  z-index: 1;

  ${({ $autoplayEnabled }) =>
    $autoplayEnabled &&
    css`
      height: auto;
    `}
`;

export const ExpandCollapseButton = styled.button`
  height: 2.4em;
  padding: 0;
  width: 2.4em;
`;

export const Icon = styled.div`
  height: 100%;
  opacity: 0.75;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ToggleContainer = styled.div<{ $autoplayExpaded: boolean }>`
  ${({ $autoplayExpaded }) =>
    $autoplayExpaded
      ? css`
          display: flex;
        `
      : css`
          display: none;
        `}

  margin-right: 2.1em;
  font-size: 14px;
`;
